import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: {
    statusLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        name: "",
        pkg: "",
        icon: "",
        status: null
      },
      imgList: [],
      rules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: "请输入包名",
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: "请上传图标",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                  _this.imgList = [data.icon];
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.imgList = e;
      this.formData.icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.icon ? [this.formDataMake.icon] : [];
      this.clearData(isClear);
    },
    resetApp: function resetApp() {
      var _this2 = this;

      this.$confirm('请确认当前操作?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$api.resetApp({
          id: _this2.formData.id
        }).then(function (res) {
          if (res.status == 200) {
            _this2.$message.success("重置成功");

            _this2.formData.appsecret = res.data;
          }
        });
      });
    },
    copyText: function copyText(text) {
      var that = this;
      this.$copyText(text).then(function (e) {
        that.$message.success("复制成功");
      }, function (e) {
        that.$message.error("复制失败");
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 9;
                    break;
                  }

                  if (!(JSON.stringify(_this3.formDataMake) == JSON.stringify(_this3.formData))) {
                    _context2.next = 4;
                    break;
                  }

                  _this3.dialogFormVisible = false;
                  return _context2.abrupt("return");

                case 4:
                  if (!_this3.formData.id) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 7;
                  return _this3.secondConfirmation();

                case 7:
                  reqFn = _this3.formData.id ? 'appListUpdate' : 'appListAdd';

                  _this3.$api[reqFn](_this3.formData).then(function (res) {
                    if (res.status == 200) {
                      _this3.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this3.dialogFormVisible = false;

                      _this3.$emit('change');
                    }
                  });

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};